/** @jsxImportSource @emotion/react */
import { TableBody } from "../../components/table-components/TableBody";
import { Table } from "../../components/table-components/Table";
import { TableRowHeader } from "../../components/table-components/TableRowHeader";
import { TableCellHeaderText } from "../../components/table-components/TableCellHeaderText";
import { firstTableCellStyle } from "../../style-util";
import { ShopProductsListRow } from "./ShopProductsListRow";
import { CardTableEmptyPlaceholder } from "../../components/table-components/CardTableEmptyPlaceholder";
import { ProductListItem } from "../products/models/product";

interface Props {
  products: ProductListItem[];
  shopId: string;
}

export const ShopProductsListTable = ({ products, shopId }: Props) => {
  if (products.length === 0) {
    return (
      <CardTableEmptyPlaceholder>
        No menu products match your filter
      </CardTableEmptyPlaceholder>
    );
  }

  return (
    <Table>
      <thead>
        <TableRowHeader>
          <TableCellHeaderText css={firstTableCellStyle}>
            Img
          </TableCellHeaderText>
          <TableCellHeaderText>Name</TableCellHeaderText>
          <TableCellHeaderText>Category</TableCellHeaderText>
          <TableCellHeaderText>Price</TableCellHeaderText>
          <th />
        </TableRowHeader>
      </thead>
      <TableBody>
        {products.map((product, i) => (
          <ShopProductsListRow key={i} product={product} shopId={shopId} />
        ))}
      </TableBody>
    </Table>
  );
};
